"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiTechLab = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var SelectAmount_1 = require("../../inputs/SelectAmount");
var CardRenderer_1 = require("../render/CardRenderer");
var HiTechLab = (function (_super) {
    __extends(HiTechLab, _super);
    function HiTechLab() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.HI_TECH_LAB,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 17,
            metadata: {
                cardNumber: 'X04',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend any amount of energy to draw the same number of cards. TAKE 1 INTO HAND AND DISCARD THE REST.', function (eb) {
                        eb.text('X').energy(1).startAction.text('X').cards(1).asterix();
                    });
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    HiTechLab.prototype.play = function () {
        return undefined;
    };
    HiTechLab.prototype.canAct = function (player) {
        return player.energy > 0;
    };
    HiTechLab.prototype.action = function (player) {
        return new SelectAmount_1.SelectAmount('Select amount of energy to spend', 'Spend energy', function (amount) {
            player.deductResource(Resources_1.Resources.ENERGY, amount);
            player.game.log('${0} spent ${1} energy', function (b) { return b.player(player).number(amount); });
            return player.drawCardKeepSome(amount, { keepMax: 1 });
        }, 1, player.energy);
    };
    HiTechLab.prototype.getVictoryPoints = function () {
        return 1;
    };
    return HiTechLab;
}(Card_1.Card));
exports.HiTechLab = HiTechLab;
//# sourceMappingURL=HiTechLab.js.map